import Backbone from 'backbone';

/**
 * Check if func is backbone view
 * @param {function} func - passed function
 * @returns {boolean} - return true if is backbone view, otherwise, return false
 */
export function isBackboneView(func = {}) {
  return func.prototype instanceof Backbone.View;
}

export function bindTo(property, extension) {
  return `$data[${JSON.stringify(property)}].${extension}`;
}
